<template>
  <v-card class="rounded-0 rounded-tl-xl rounded-tr-xl mr-auto" :width="width"  style=" bottom: -5px; z-index:0;" :elevation="elevation">
    <v-tabs dense height="48px" color="teal darken-4"
        :value="tab" outline centered @change="emitInput" >
        <v-tab v-for="(item, key) in tabItems" :key="key" :class="`${key == 0 ? 'ml-0' : ''}`"> {{ item }} 
        </v-tab>
        <!-- <v-tab class="mr-4" >Ngày cấp phép năm
        </v-tab> -->
        <!-- <v-tab>
            Grid test
        </v-tab> -->
    </v-tabs>
</v-card>
</template>

<script>
export default {
  name: 'CardTab',
  props:['tab', 'tabItems', 'elevation', 'width'],
  methods: {
    emitInput(val) {
      this.$emit('input', val)
    }
  }
}
</script>